/**
 * Display helpers shared by the email compose and link dialogs, which both pick a unit and then a tenant.
 */

import { realUnitNumber } from '@resida/shared';
import type { UnitWithRelations, TenantWithDetails } from '../../lib/api';

/** "Property — Unit 4B", or just the property for a single-unit property (never the literal "DEFAULT"). */
export function unitOptionLabel(unit: UnitWithRelations): string {
  const propertyName = unit.propertyName ?? unit.property?.name ?? '';
  const real = realUnitNumber(unit.unitNumber);
  if (real) {
    return `${propertyName} — Unit ${real}`.trimStart();
  }
  return propertyName || 'Single Family';
}

export function tenantDisplayName(tenant: TenantWithDetails): string {
  return `${tenant.firstName || ''} ${tenant.lastName || ''}`.trim() || tenant.email;
}

/** Tenants a landlord can email or link to: active or pending, reachable by identity or email. */
export function isReachableTenant(tenant: TenantWithDetails): boolean {
  return ['active', 'pending'].includes(tenant.status) && Boolean(tenant.identityId || tenant.email);
}
